module.exports = ".card-header button,.card-header label{\r\n    cursor: default;\r\n}\r\n.response {\r\n    padding: 20px;\r\n    background-color:  #41444e;\r\n    color:white;\r\n    min-height: 100px;\r\n    border: 1px solid back;\r\n    border-radius: 4px;\r\n    vertical-align: middle;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/try-it/try-it.component.css
// module id = ./src/app/common/components/try-it/try-it.component.css
// module chunks = main